<template>
  <section class="series-new" v-if="isReady" id="series-new">
    <img src="@/assets/img/line.png" class="series-new__line series-new__line--top" alt="" loading="lazy" />
    <div class="series-new-head">
      <div class="series-new-head__title">Pulpy знает, как встряхнуть неловкость в&nbsp;любой <br>ситуации</div>
    </div>

    <div class="series-new__block">
      <swiper
        class="series-new-swiper"
        :modules="modules"
        :slides-per-view="1"
        :space-between="0"
        :loop="true"
        :thumbs="{ swiper: thumbsSwiper }" 
      >
        <template #wrapper-start>
          <swiper-slide
            v-for="(item, i) in serieses"
            :key="i"
          >
            <iframe :src="item.src" width="853" height="480" allow="autoplay; encrypted-media; fullscreen; picture-in-picture; screen-wake-lock;" frameborder="0" allowfullscreen></iframe>
          </swiper-slide>
        </template>
      </swiper>
      <swiper
        class="series-new-swiper-thumbs"
        :modules="modules"
        @swiper="setThumbsSwiper"
        :navigation="{
          prevEl: prev,
          nextEl: next,
        }"
        slidesPerView="3"
        :spaceBetween="20"
        :breakpoints="{ 600:{ slidesPerView:3 }, 900:{ slidesPerView:6, } }"
        :centeredSlides="false"
        :loop="false"
        :slideToClickedSlide="true"
        ref="swiper"
      >
        <template #wrapper-start>
          <swiper-slide
            v-for="(item, i) in serieses"
            :key="i"
          >
            <img :src="item.img" class="series-new-swiper-thumbs__img" alt="">
            <span>{{ item.name }}</span>
          </swiper-slide>
        </template>
      </swiper>
      <div class="series-new-navigation">
        <div ref="prev" class="series-new-navigation-prev">
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="20" cy="20" r="20" fill="black" fill-opacity="0.2"/>
            <path d="M22.9167 13.333L16.25 19.9997L22.9167 26.6663" stroke="white" stroke-width="3"/>
          </svg>
        </div>
        <div ref="next" class="series-new-navigation-next">
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="20" cy="20" r="20" transform="matrix(-1 0 0 1 40 0)" fill="black" fill-opacity="0.2"/>
            <path d="M17.0833 13.333L23.75 19.9997L17.0833 26.6663" stroke="white" stroke-width="3"/>
          </svg>
        </div>
      </div>
    </div>
    <img src="@/assets/img/line.png" class="series__line" alt="" loading="lazy" />
  </section>
</template>

<script>
import { ref } from 'vue';

import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay, Navigation, Thumbs } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';

export default {
  components: { Swiper, SwiperSlide },
  name: 'ProductsBlock',
  setup() {
    const prev = ref(null);
    const next = ref(null);
    const serieses = ref([
      {
        name: '1 серия',
        src: 'https://vk.com/video_ext.php?oid=-72874935&id=456239414&hd=2&autoplay=0',
        img: '/video-preview/preview-1.png'
      },
      {
        name: '2 серия',
        src: 'https://vk.com/video_ext.php?oid=-72874935&id=456239406&hd=2&autoplay=0',
        img: '/video-preview/preview-2.png'
      }
    ]);
    return { 
      modules: [Autoplay, Navigation, Thumbs],prev,
      next,
      serieses,
    };
  },
  data() {
    return {
      isReady: false,
      thumbsSwiper: null
    };
  },

  methods: {
    setThumbsSwiper(swiper) {
      this.thumbsSwiper = swiper;
    },
  },
  async mounted() {
    await this.$store.dispatch('getSerieses');
    this.isReady = true;
  },
};
</script>

<style lang="scss">
@import 'series-new';

p {
  white-space: pre-wrap;
}
</style>
